import { ThemeSelector } from '../theme'

import { UserProfileButton } from './user'

export const RootHeaderButtons = () => (
  <div className='flex items-center justify-end gap-[6px]'>
    <ThemeSelector />
    {/* <NotificationsHeaderButton /> */}
    <UserProfileButton />
  </div>
)
